import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Row from './Row';
import Col from './Col';
import createProps from './createProps';

import './grid.css';

const Grid = (props) => {
  const containerClass = props.fluid ? 'container-fluid' : 'container';
  const className = classNames(props.className, containerClass);

  return React.createElement(props.tagName || 'div', createProps(props, className));
};

Grid.propTypes = {
  fluid: PropTypes.bool,
  className: PropTypes.string,
  tagName: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export { Grid, Col, Row };
